import { cloneElement, FC } from 'react';
import { Tooltip } from 'react-tooltip';
import { IComponentWithTooltipProps } from './types';
import styles from './componentWithTooltip.module.scss';

export const ComponentWithTooltip: FC<IComponentWithTooltipProps> = ({
  component,
  name,
  message,
  place = 'right',
  // stylesProp,
}) => {
  const cloneChild = (child: React.ReactElement) => {
    return cloneElement(child, { 'data-tooltip-id': name });
  };
  return (
    <>
      {cloneChild(component)}
      {/* Was made due to error on localhost ResizeObserver loop completed with undelivered notifications. */}
      {process.env.NODE_ENV !== 'development' && (
        <Tooltip place={place} id={name} delayHide={100}>
          <span className={styles.errorMsg}>{message}</span>
        </Tooltip>
      )}
    </>
  );
};
